export const titleCodes = {
    jewellery: {
        code: "${merchantId}_tmpl_title_7",
        title: "29 Jewellery - 29ရတနာ"
    },

    shop1: {
        code: "${merchantId}_tmpl_title_4",
        title: "29ရတနာ ဆိုင် (၁)"
    },

    shop2: {
        code: "${merchantId}_tmpl_title_5",
        title: "29ရတနာ ဆိုင် (၂)"
    },

    shop3: {
        code: "${merchantId}_tmpl_title_6",
        title: "29ရတနာ ဆိုင် (၃)"
    },
}


export const textCodes = {
    shop1Addr: {
        code: "${merchantId}_tmpl_text_16",
        text: "အမှတ် (၁၉၇ ၊၁၉၈ ၊၁၉၉ ) အရှေ့ဘက်တိုက်တန်း ၊ ယာဥ်ထွက်ပေါက် ထိပ် ၊ ဗိုလ်ချုပ်အောင်ဆန်းစျေး ၊ ရန်ကုန်မြို့။"
    },

    shop1Ph: {
        code: "${merchantId}_tmpl_text_17",
        text: "09-787292929 , 09-767 292929"
    },

    shop2Addr: {
        code: "${merchantId}_tmpl_text_18",
        text: "တိုက်အမှတ် ( ၁၈ ) ၊ ဦးချစ်မောင် အိမ်ယာ ၊ တာမွေကြီး ( ခ ) ရပ်ကွက် ၊ တာမွေမြို့နယ် ၊ ရန်ကုန်မြို့။"
    },

    shop2Ph: {
        code: "${merchantId}_tmpl_text_19",
        text: "09-886 292929 , 09-885 29292929"
    },

    shop3Addr: {
        code: "${merchantId}_tmpl_text_20",
        text: "29 ရတနာဆိုင် (၃ ) အမှတ် ( ၇၇၇ ) ၊ လမ်းမတော်မြို့နယ် ၊ မဟာဗန္ဓုလ လမ်း နှင့် (၁၄ ) လမ်းထောင့် ၊ လသာမြို့နယ် ၊ ရန်ကုန်မြို့။"
    },

    shop3Ph: {
        code: "${merchantId}_tmpl_text_21",
        text: "09-951 292929 , 09-952 292929"
    },

    description: {
        code: "${merchantId}_tmpl_text_30",
        text: "ယုံကြည်ရလို့ စိတ်ချမ်းသာ ဝယ်သူပျော်တာ 29ရတနာ"
    },
}
